"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.assertNonEmptyString = exports.assertLeadingSlash = void 0;
exports.firstOfType = firstOfType;
exports.isAbsoluteUrl = exports.getStaticBasedPath = exports.getRootBasedUrl = void 0;
exports.jsonDeserializeState = jsonDeserializeState;
exports.jsonSerializeState = jsonSerializeState;
exports.validatePath = exports.unicodeSymbolsForEscape = exports.optionsInjector = exports.makeMonitoringSafe = exports.makeMiddlewareApplier = exports.jsonUtfStringify = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _url = _interopRequireDefault(require("url"));

var _symbols = require("./symbols");

function firstOfType(selector) {
  for (var _len = arguments.length, vars = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    vars[_key - 1] = arguments[_key];
  }

  return vars.find(function (i) {
    return selector(i);
  });
}

var createSafeHandler = function createSafeHandler(fn) {
  return function () {
    try {
      fn.apply(void 0, arguments);
    } catch (e) {}
  };
};

var makeMonitoringSafe = function makeMonitoringSafe(monitoring) {
  return (0, _extends2["default"])({}, monitoring, {
    error: monitoring.error ? createSafeHandler(monitoring.error) : monitoring.error
  });
};

exports.makeMonitoringSafe = makeMonitoringSafe;

var makeMiddlewareApplier = function makeMiddlewareApplier(middlewares) {
  var reversedMiddlewares = middlewares.slice().reverse();
  return function (targetHandler) {
    var handlersChain = targetHandler;
    reversedMiddlewares.forEach(function (middleware) {
      return handlersChain = middleware(handlersChain);
    });
    return handlersChain;
  };
};

exports.makeMiddlewareApplier = makeMiddlewareApplier;
var regExpAbsoluteUrl = new RegExp('^(?:[a-z]+:)?//', 'i');

var isAbsoluteUrl = function isAbsoluteUrl(value) {
  return regExpAbsoluteUrl.test(value);
};

exports.isAbsoluteUrl = isAbsoluteUrl;

var assertLeadingSlash = function assertLeadingSlash(value, name) {
  if (!(value != null && value.startsWith('/'))) {
    // eslint-disable-next-line no-console
    console.error(value);
    throw Error((name !== null && name !== void 0 ? name : 'the value') + " must have leading \"/\"");
  }
};

exports.assertLeadingSlash = assertLeadingSlash;

var assertNonEmptyString = function assertNonEmptyString(value, name) {
  if (!value || value === '' || value.trim() === '') {
    // eslint-disable-next-line no-console
    console.error(value);
    throw Error((name !== null && name !== void 0 ? name : 'the value') + " should not be empty \"/\"");
  }
};

exports.assertNonEmptyString = assertNonEmptyString;

var getRootBasedUrl = function getRootBasedUrl(rootPath, path, origin) {
  if (isAbsoluteUrl(path)) {
    return path;
  }

  assertLeadingSlash(path, 'Path');
  return "" + (origin !== null && origin !== void 0 ? origin : '') + (rootPath ? "/" + rootPath : '') + path;
};

exports.getRootBasedUrl = getRootBasedUrl;

var getStaticBasedPath = function getStaticBasedPath(rootPath, staticPath, filename) {
  assertNonEmptyString(staticPath, 'Static path');
  assertNonEmptyString(filename, 'Filename');
  var fineStaticPath = staticPath != null && staticPath.endsWith('/') ? staticPath : staticPath + "/";

  var path = _url["default"].resolve(fineStaticPath, "./" + filename);

  var pathPrefix = path != null && path.startsWith('/') ? '' : '/';
  return getRootBasedUrl(rootPath, isAbsoluteUrl(path) ? path : "" + pathPrefix + path);
}; // Based on Unicode character list: http://www.unicode.org/notes/tn36/Categories.txt


exports.getStaticBasedPath = getStaticBasedPath;
var unicodeSymbolsForEscape = "\n  [\\0-\\x1F\\x7F-\\x9F\\xAD\\u0378\\u0379\\u037F-\\u0383\\u038B\n  \\u03A2\\u0528-\\u0530\\u0557\\u0558\\u0560\\u0588\\u058B-\\u058E\\u0590\\u05C8-\\u05CF\n  \\u05EB-\\u05EF\\u05F5-\\u0605\\u061C\\u061D\\u06DD\\u070E\\u070F\\u074B\\u074C\\u07B2-\n  \\u07BF\\u07FB-\\u07FF\\u082E\\u082F\\u083F\\u085C\\u085D\\u085F-\\u089F\\u08A1\\u08AD-\n  \\u08E3\\u08FF\\u0978\\u0980\\u0984\\u098D\\u098E\\u0991\\u0992\\u09A9\\u09B1\\u09B3-\n  \\u09B5\\u09BA\\u09BB\\u09C5\\u09C6\\u09C9\\u09CA\\u09CF-\\u09D6\\u09D8-\\u09DB\\u09DE\n  \\u09E4\\u09E5\\u09FC-\\u0A00\\u0A04\\u0A0B-\\u0A0E\\u0A11\\u0A12\\u0A29\\u0A31\\u0A34\n  \\u0A37\\u0A3A\\u0A3B\\u0A3D\\u0A43-\\u0A46\\u0A49\\u0A4A\\u0A4E-\\u0A50\\u0A52-\\u0A58\n  \\u0A5D\\u0A5F-\\u0A65\\u0A76-\\u0A80\\u0A84\\u0A8E\\u0A92\\u0AA9\\u0AB1\\u0AB4\\u0ABA\n  \\u0ABB\\u0AC6\\u0ACA\\u0ACE\\u0ACF\\u0AD1-\\u0ADF\\u0AE4\\u0AE5\\u0AF2-\\u0B00\\u0B04\n  \\u0B0D\\u0B0E\\u0B11\\u0B12\\u0B29\\u0B31\\u0B34\\u0B3A\\u0B3B\\u0B45\\u0B46\\u0B49\n  \\u0B4A\\u0B4E-\\u0B55\\u0B58-\\u0B5B\\u0B5E\\u0B64\\u0B65\\u0B78-\\u0B81\\u0B84\\u0B8B-\n  \\u0B8D\\u0B91\\u0B96-\\u0B98\\u0B9B\\u0B9D\\u0BA0-\\u0BA2\\u0BA5-\\u0BA7\\u0BAB-\\u0BAD\n  \\u0BBA-\\u0BBD\\u0BC3-\\u0BC5\\u0BC9\\u0BCE\\u0BCF\\u0BD1-\\u0BD6\\u0BD8-\\u0BE5\\u0BFB-\n  \\u0C00\\u0C04\\u0C0D\\u0C11\\u0C29\\u0C34\\u0C3A-\\u0C3C\\u0C45\\u0C49\\u0C4E-\\u0C54\n  \\u0C57\\u0C5A-\\u0C5F\\u0C64\\u0C65\\u0C70-\\u0C77\\u0C80\\u0C81\\u0C84\\u0C8D\\u0C91\n  \\u0CA9\\u0CB4\\u0CBA\\u0CBB\\u0CC5\\u0CC9\\u0CCE-\\u0CD4\\u0CD7-\\u0CDD\\u0CDF\\u0CE4\n  \\u0CE5\\u0CF0\\u0CF3-\\u0D01\\u0D04\\u0D0D\\u0D11\\u0D3B\\u0D3C\\u0D45\\u0D49\\u0D4F-\n  \\u0D56\\u0D58-\\u0D5F\\u0D64\\u0D65\\u0D76-\\u0D78\\u0D80\\u0D81\\u0D84\\u0D97-\\u0D99\n  \\u0DB2\\u0DBC\\u0DBE\\u0DBF\\u0DC7-\\u0DC9\\u0DCB-\\u0DCE\\u0DD5\\u0DD7\\u0DE0-\\u0DF1\n  \\u0DF5-\\u0E00\\u0E3B-\\u0E3E\\u0E5C-\\u0E80\\u0E83\\u0E85\\u0E86\\u0E89\\u0E8B\\u0E8C\n  \\u0E8E-\\u0E93\\u0E98\\u0EA0\\u0EA4\\u0EA6\\u0EA8\\u0EA9\\u0EAC\\u0EBA\\u0EBE\\u0EBF\n  \\u0EC5\\u0EC7\\u0ECE\\u0ECF\\u0EDA\\u0EDB\\u0EE0-\\u0EFF\\u0F48\\u0F6D-\\u0F70\\u0F98\n  \\u0FBD\\u0FCD\\u0FDB-\\u0FFF\\u10C6\\u10C8-\\u10CC\\u10CE\\u10CF\\u1249\\u124E\\u124F\n  \\u1257\\u1259\\u125E\\u125F\\u1289\\u128E\\u128F\\u12B1\\u12B6\\u12B7\\u12BF\\u12C1\n  \\u12C6\\u12C7\\u12D7\\u1311\\u1316\\u1317\\u135B\\u135C\\u137D-\\u137F\\u139A-\\u139F\n  \\u13F5-\\u13FF\\u169D-\\u169F\\u16F1-\\u16FF\\u170D\\u1715-\\u171F\\u1737-\\u173F\n  \\u1754-\\u175F\\u176D\\u1771\\u1774-\\u177F\\u17DE\\u17DF\\u17EA-\\u17EF\\u17FA-\\u17FF\n  \\u180F\\u181A-\\u181F\\u1878-\\u187F\\u18AB-\\u18AF\\u18F6-\\u18FF\\u191D-\\u191F\\u192C-\n  \\u192F\\u193C-\\u193F\\u1941-\\u1943\\u196E\\u196F\\u1975-\\u197F\\u19AC-\\u19AF\\u19CA-\n  \\u19CF\\u19DB-\\u19DD\\u1A1C\\u1A1D\\u1A5F\\u1A7D\\u1A7E\\u1A8A-\\u1A8F\\u1A9A-\n  \\u1A9F\\u1AAE-\\u1AFF\\u1B4C-\\u1B4F\\u1B7D-\\u1B7F\\u1BF4-\\u1BFB\\u1C38-\\u1C3A\n  \\u1C4A-\\u1C4C\\u1C80-\\u1CBF\\u1CC8-\\u1CCF\\u1CF7-\\u1CFF\\u1DE7-\\u1DFB\\u1F16\n  \\u1F17\\u1F1E\\u1F1F\\u1F46\\u1F47\\u1F4E\\u1F4F\\u1F58\\u1F5A\\u1F5C\\u1F5E\\u1F7E\n  \\u1F7F\\u1FB5\\u1FC5\\u1FD4\\u1FD5\\u1FDC\\u1FF0\\u1FF1\\u1FF5\\u1FFF\\u200B-\\u200F\n  \\u202A-\\u202E\\u2060-\\u206F\\u2072\\u2073\\u208F\\u209D-\\u209F\\u20BB-\\u20CF\\u20F1-\n  \\u20FF\\u218A-\\u218F\\u23F4-\\u23FF\\u2427-\\u243F\\u244B-\\u245F\\u2700\\u2B4D-\\u2B4F\n  \\u2B5A-\\u2BFF\\u2C2F\\u2C5F\\u2CF4-\\u2CF8\\u2D26\\u2D28-\\u2D2C\\u2D2E\\u2D2F\\u2D68-\n  \\u2D6E\\u2D71-\\u2D7E\\u2D97-\\u2D9F\\u2DA7\\u2DAF\\u2DB7\\u2DBF\\u2DC7\\u2DCF\\u2DD7\n  \\u2DDF\\u2E3C-\\u2E7F\\u2E9A\\u2EF4-\\u2EFF\\u2FD6-\\u2FEF\\u2FFC-\\u2FFF\\u3040\\u3097\n  \\u3098\\u3100-\\u3104\\u312E-\\u3130\\u318F\\u31BB-\\u31BF\\u31E4-\\u31EF\\u321F\\u32FF\n  \\u4DB6-\\u4DBF\\u9FCD-\\u9FFF\\uA48D-\\uA48F\\uA4C7-\\uA4CF\\uA62C-\\uA63F\\uA698-\n  \\uA69E\\uA6F8-\\uA6FF\\uA78F\\uA794-\\uA79F\\uA7AB-\\uA7F7\\uA82C-\\uA82F\\uA83A-\n  \\uA83F\\uA878-\\uA87F\\uA8C5-\\uA8CD\\uA8DA-\\uA8DF\\uA8FC-\\uA8FF\\uA954-\\uA95E\\uA97D-\n  \\uA97F\\uA9CE\\uA9DA-\\uA9DD\\uA9E0-\\uA9FF\\uAA37-\\uAA3F\\uAA4E\\uAA4F\\uAA5A\\uAA5B\n  \\uAA7C-\\uAA7F\\uAAC3-\\uAADA\\uAAF7-\\uAB00\\uAB07\\uAB08\\uAB0F\\uAB10\\uAB17-\\uAB1F\n  \\uAB27\\uAB2F-\\uABBF\\uABEE\\uABEF\\uABFA-\\uABFF\\uD7A4-\\uD7AF\\uD7C7-\\uD7CA\\uD7FC-\n  \\uF8FF\\uFA6E\\uFA6F\\uFADA-\\uFAFF\\uFB07-\\uFB12\\uFB18-\\uFB1C\\uFB37\\uFB3D\\uFB3F\n  \\uFB42\\uFB45\\uFBC2-\\uFBD2\\uFD40-\\uFD4F\\uFD90\\uFD91\\uFDC8-\\uFDEF\\uFDFE\\uFDFF\n  \\uFE1A-\\uFE1F\\uFE27-\\uFE2F\\uFE53\\uFE67\\uFE6C-\\uFE6F\\uFE75\\uFEFD-\\uFF00\\uFFBF-\n  \\uFFC1\\uFFC8\\uFFC9\\uFFD0\\uFFD1\\uFFD8\\uFFD9\\uFFDD-\\uFFDF\\uFFE7\\uFFEF-\n  \\uFFFB\\u038D\\uFFFE\\uFFFF]\n";
exports.unicodeSymbolsForEscape = unicodeSymbolsForEscape;
var unicodeEscapeRegex = new RegExp(unicodeSymbolsForEscape.replace(/\s/g, ''), 'g');

function escapeUnicodeSymbol(match) {
  var _match$codePointAt;

  var code = (_match$codePointAt = match.codePointAt(0)) !== null && _match$codePointAt !== void 0 ? _match$codePointAt : 0;
  return "\\u" + code.toString(16).padStart(4, '0');
}

var jsonUtfStringify = function jsonUtfStringify(inputObject) {
  return JSON.stringify(inputObject).replace(unicodeEscapeRegex, escapeUnicodeSymbol);
};

exports.jsonUtfStringify = jsonUtfStringify;

function jsonDeserializeState(state) {
  return JSON.parse(state);
}

jsonDeserializeState[_symbols.IS_BUILT_IN] = true;

function jsonSerializeState(state) {
  return JSON.stringify(state, null, 2);
}

jsonSerializeState[_symbols.IS_BUILT_IN] = true; // Used in clientImports to map options to context

var optionsInjector = function optionsInjector(options, imports) {
  void imports;
  return options;
};

exports.optionsInjector = optionsInjector;

var validatePath = function validatePath(url, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      allowEmptyPath = _ref.allowEmptyPath,
      allowAbsolutePath = _ref.allowAbsolutePath;

  if (url === '' && !allowEmptyPath) {
    return false;
  }

  try {
    var _Url$parse = _url["default"].parse(url),
        protocol = _Url$parse.protocol,
        slashes = _Url$parse.slashes,
        auth = _Url$parse.auth,
        host = _Url$parse.host,
        port = _Url$parse.port,
        hostname = _Url$parse.hostname,
        hash = _Url$parse.hash,
        search = _Url$parse.search,
        query = _Url$parse.query;

    if (!allowAbsolutePath && (protocol || slashes || host || port || hostname)) {
      return false;
    }

    if (auth || hash || search || query || /^\//.test(url) || /\/$/.test(url)) {
      return false;
    }

    return true;
  } catch (error) {
    return false;
  }
};

exports.validatePath = validatePath;
//# sourceMappingURL=helpers.js.map